import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/2026_EK-Liga_quer_w.png")